import { Center, Column } from '@tempmee/react';
import { CenteredSpinner } from '~/commonComponents';
import { CandidateStatus } from '~/domain/PermanentJobs';
import { CandidateStatusFilterPanel } from '../../../components';
import { CandidateListTableV2 } from './CandidateListTable';
import { useCandidateTabView } from './useCandidateTabView';

interface ICandidateTabViewProps {
  jobPostingId: string;
  officeId: string;
}

export const CandidateTabView = ({ jobPostingId, officeId }: ICandidateTabViewProps) => {
  const { data, filters, isInitialLoading, isLoading, methods, pagination, statistics } =
    useCandidateTabView(jobPostingId);

  const hideInviteAndShortlistColumn =
    filters.status === CandidateStatus.Hired || filters.status === CandidateStatus.Rejected;

  return (
    <Column px={20}>
      <CandidateStatusFilterPanel counts={statistics.tabs} onChange={methods.setStatusFilter} />
      {isInitialLoading ? (
        <Center style={{ marginBlock: 32 }}>
          <CenteredSpinner />
        </Center>
      ) : (
        <CandidateListTableV2
          data={data}
          hideInviteColumn={hideInviteAndShortlistColumn}
          hideShortlistColumn={hideInviteAndShortlistColumn}
          isLoading={isLoading}
          jobPostingId={jobPostingId}
          officeId={officeId}
          onPageChange={methods.setCurrentPage}
          onSortingChange={methods.setSorting}
          pagination={pagination}
          sorting={filters.sorting}
        />
      )}
    </Column>
  );
};
